import { CommentPlusOutlineIcon } from './CommentPlusOutlineIcon';

/**
 * author: Austin Andrews
 * id 813C3AFA-56D8-472B-8C1C-C365AC752663
 * name comment-plus-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-plus-outline.svg
 * tags
 */
export const CommentAddOutlineIcon = CommentPlusOutlineIcon;
export default CommentAddOutlineIcon